interface SocialLink {
  href: string;
  label: string;
  icon: React.ReactNode;
}

import { Mail, Linkedin, Github } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useSound } from '../../hooks/audio/useSound';

const SOCIAL_LINKS: SocialLink[] = [
  {
    href: 'https://www.linkedin.com/in/amandine-quellec',
    label: 'LinkedIn',
    icon: <Linkedin size={20} />,
  },
  {
    href: 'https://github.com/aquellec',
    label: 'GitHub',
    icon: <Github size={20} />,
  },
];

export const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const { playUI } = useSound();
  const isFixed = pathname !== '/about';

  return (
    <footer
      className={`z-20 p-4 text-black md:p-8 ${
        isFixed
          ? 'fixed inset-x-0 bottom-0 md:inset-x-auto md:right-0'
          : 'relative'
      }`}
    >
      <div className="flex w-full flex-row items-end justify-center gap-4 md:w-auto md:justify-end sm:items-center">
        <a
          href="mailto:quellec.amandine@gmail.com"
          className="body group min-w-0 flex items-center gap-2 opacity-0 animate-fade-in"
          style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}
          onMouseEnter={() => playUI('footer', 'enter')}
          onMouseLeave={() => playUI('footer', 'leave')}
        >
          <Mail
            size={20}
            className="transition-transform duration-300 group-hover:-translate-y-1"
          />
          <span className="truncate transition-all duration-300 group-hover:-translate-y-1">
            quellec.amandine@gmail.com
          </span>
        </a>
        <div className="flex items-center gap-4">
          {SOCIAL_LINKS.map(({ href, label, icon }, i) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 opacity-0 animate-fade-in"
              style={{
                animationDelay: `${1000 + i * 200}ms`,
                animationFillMode: 'forwards',
              }}
              onMouseEnter={() => playUI('footer', 'enter')}
              onMouseLeave={() => playUI('footer', 'leave')}
            >
              <div className="transition-transform duration-300 group-hover:-translate-y-1">
                {icon}
              </div>
              <span className="sr-only">{label}</span>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};
